import React from 'react';
import { Col } from 'antd';
import PropTypes from 'prop-types';
import Button from './Button';

const FormActionButtonWithCancel = (props) => {
  const { handleSubmit, handleCancel, loadingButton } = props;
  return (
    <Col className="footer-form" span={24}>
      {handleCancel
        && (
          <Button
            className="btn-save"
            icon="close-circle"
            onClick={handleCancel}
          >
            Hủy
          </Button>
        )}
      {handleSubmit
        && (
          <Button
            className="btn-save"
            icon="save"
            loading={loadingButton}
            onClick={handleSubmit}
            type="primary submit"
          >
            Lưu
          </Button>
        )}
    </Col>
  );
};

FormActionButtonWithCancel.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  loadingButton: PropTypes.bool.isRequired
};
export default FormActionButtonWithCancel;
